import { prepareCommonCarriageData, sendCarriage } from "./sendCarriageCommon";
import { type LinearConfigurationUpdate } from "../../Linear/models";
import { prepareApiDataForResetOld, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "../../Linear/redux/types";

export function sendCarriageDataReset(linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonCarriageData(linearState);
  const resetData = prepareApiDataForResetOld(linearState);

  // In Step 1 we need to set a flag to uncheck the large design - in case it is selected
  if (linearState.currentStep === 0) {
    data.carriagesConfiguratorData.largeDesignSelected = false;
  }
  if (linearState.currentStep === 2) {
    data.carriagesConfiguratorData.resetCarriageDetails = true;
    data.carriagesConfiguratorData.enableConfigureCarriageValues = false;
  }

  prepareGroupIdToDisplay(data);

  // For Step 3 - we need to send a special flag to reload the default values for the carriage details substep
  if (linearState.currentStep === 2) {
    data.carriagesConfiguratorData.resetCarriageDetails = true;
    data.carriagesConfiguratorData.enableConfigureCarriageValues = false;
  }

  return sendCarriage({
    ...data,
    ...resetData,
  });
}
